import React, { useState, useContext, useEffect } from "react";
import { Utils, UserContext } from "./../../common";
import { Card, Row, Col, Modal, Button, Alert, Spinner, Table } from "react-bootstrap";
import _ from "lodash";
import axios from "axios";
import moment from "moment";

const ChoosePlans = (props) => {
  const { userData, addToUserData } = useContext(UserContext);
  const [ sitePlans, setSitePlans ] = useState(false);
  const [ planModules, setPlanModules ] = useState([]);
  const [ selplan, setSelplan ] = useState(false);
  const [askdis, setAskdis] = useState(false);
  const [coupon, setCoupon] = useState('');
  const [making, setMaking] = useState(false);
  const [upgradeStatus,setUpgradeStatus] = useState({mode: 0, msg: ""}); //== 0: nothing, 1: success, 2: failed
  
  useEffect(() => {
    const loadPlans = () => {
      axios.get(Utils.apiUrl("payment/plans"), Utils.apiHeaders())
        .then((res) => {
          if (res.data && res.data.success && Array.isArray(res.data.plans)) {
            setSitePlans(res.data.plans);
            setPlanModules(res.data.modules || []);
            if (typeof window !== "undefined") {
              window["plans"] = res.data.plans;
              window["modules"] = res.data.modules || [];
            }
          } else {
            fallbackScriptLoad();
          }
        })
        .catch(() => {
          fallbackScriptLoad();
        });
    };

    const fallbackScriptLoad = () => {
      if (typeof window !== "undefined" && window["plans"] && window["modules"]) {
        setSitePlans(window["plans"]);
        setPlanModules(window["modules"] || []);
        return;
      }
      const script = document.createElement("script");
      script.src = "/admin/assets/plans.js?t=" + Date.now();
      script.onload = () => {
        if (window["plans"]) {
          setSitePlans(window["plans"]);
          setPlanModules(window["modules"] || []);
        }
      };
      document.body.appendChild(script);
    };

    loadPlans();
  }, []);

  const hasActivePlan = () => {
    return _.get(userData,'plan.id',0) > 0 && moment().isBefore(_.get(userData,'plan_expires',false));
  };

  const handleInAppSuccess = (data, message) => {
    setMaking(false);
    if (data) {
      addToUserData(data);
    }
    if (typeof props.onPayment === 'function') {
      props.onPayment();
    }
    setUpgradeStatus({mode: 1, message: message || "Your plan has been activated successfully."});
  };

  const makePayment = () => {
    setMaking(true);
    setAskdis(false);
    var usecoupon = coupon;
    setCoupon("");
    setUpgradeStatus({mode: 0});
    const upgrading = hasActivePlan();
    return axios.post(Utils.apiUrl("payment/makepayment"), `plan_id=${selplan.id}${upgrading ? '&mode=upgrade' : ''}&coupon=${encodeURIComponent(usecoupon || '')}`, Utils.apiHeaders())
    .then((res) => {
      const payload = res.data || {};
      if (!payload.success) {
        setSelplan(false);
        setMaking(false);
        setUpgradeStatus({mode: 2, message: payload.error || payload.message || "Payment failed. Please try again."});
        return;
      }

      // Stripe Checkout URL — redirect to payment page
      if (payload.pg_url) {
        window.location.href = payload.pg_url;
        return;
      }

      // In-app activation (upgrade or free plan) — no Stripe redirect
      handleInAppSuccess(
        payload.data,
        upgrading
          ? "Your plan has been upgraded successfully."
          : "Your plan has been activated successfully."
      );
    })
    .catch((err) => {
      setSelplan(false);
      setMaking(false);
      const msg = _.get(err, 'response.data.error')
        || _.get(err, 'response.data.message')
        || err.message
        || "Payment request failed. Please try again.";
      setUpgradeStatus({mode: 2, message: msg});
    });
  };

  const renderPlan = (p,showThisPlan) => {
    let planmods = [];
    try {
      let rawMods = typeof p.modules === "string" ? JSON.parse(p.modules) : (p.modules || []);
      if (typeof rawMods === "string") {
        rawMods = JSON.parse(rawMods);
      }
      if (Array.isArray(rawMods)) {
        planmods = rawMods.map((x) => String(x).trim());
      }
    } catch(e) {
      planmods = [];
    }
    const modulesList = planModules.length > 0 ? planModules : (window['modules'] || []);
  
    return showThisPlan ? <div key={p.id} className="col-md-4 col-sm-4">
        <div className="planbox">
          <h4><b>{p.name}</b></h4>
          <ul className="autopilot mb-4">
            {modulesList.map(m => {
              const isIncluded = planmods.includes(String(m.id));
              return (
                <li key={m.id}>
                  <img src={`${process.env.PUBLIC_URL}/images/${isIncluded ? 'check2' : 'iclose'}.png`} alt="#" /> {m.title}
                </li>
              );
            })}
          </ul>
          <h5><b>{p.cost} + VAT</b></h5>
          <div className="button4" onClick={()=>{setSelplan(p);setAskdis(true);}}>Choose</div>
        </div>
      </div> : <></>;
  };

  const renderPlans = () => {

    let anyplans = false;
    let showThisPlan = false;

    return <>
    {sitePlans.map(p => {
      showThisPlan = parseInt(_.get(userData,'plan.id',0)) !== parseInt(p.id);// && parseFloat(p.cost) > parseFloat(_.get(userData,'plan.cost',0));
      if(showThisPlan) { anyplans = true;}
      return renderPlan(p, showThisPlan);
    })}
    {!anyplans && <Alert variant="warning">You are already subscribed on the highest plan.</Alert>}
    </>;
  };

  const renderAskDis = () => {
    return <Modal show={askdis} centered>
        <Modal.Header style={{ borderBottom: "0" }} className="pb-0 mb-0">
          <img
            src={`${process.env.PUBLIC_URL}/images/close.png`}
            className="ms-auto clickable"
            title="Close"
            alt="Close"
            onClick={() => setAskdis(false)}
          />
        </Modal.Header>
        <Modal.Body className="bg-white text-center px-5">
          <img src={`${process.env.PUBLIC_URL}/images/circle.png`} className="mb-3" alt="Information" style={{width: 50}} />
          <h4 className="mb-4">Coupon Code</h4>
          <input type="text" className="form-control" placeholder="Enter coupon code" onChange={(e) => setCoupon(e.currentTarget.value)} value={coupon} />
          <div className="alert alert-warning" style={{fontSize: 12}}>If you do not have any coupon code, please leave this blank and proceed with "Make Payment".</div>
          <Button variant="primary" className="d-block mx-auto mt-2 mb-4 w-100" onClick={(e)=> makePayment()}>Make Payment</Button>
        </Modal.Body>
      </Modal>
  };

  return <Row className="mt-0 mt-sm-4">
  
    
          {sitePlans===false && <Col><Spinner animation="border" role="status"></Spinner><span className="p-2">Loading Plans...</span></Col>}
          {sitePlans && <>
            {making && <Col><Spinner animation="border" role="status"></Spinner><span className="p-2">Payment initiated, please wait...</span></Col>}
            {!making && <>
              {upgradeStatus.mode > 0 && <div className="px-3"><Alert variant={upgradeStatus.mode === 1? "success" : "danger"}>{upgradeStatus.message}</Alert></div>}
              {renderPlans()}
              {askdis && renderAskDis()}
            </>}
            
          </>}
        
  </Row>;
};

export default ChoosePlans;
